import React from 'react'

export const lms = [
  {
    name: 'Adicionar conteúdo',
    component: React.lazy(() => import('../../modules/LMS/Lecture')),
    path: '/professor/lecure-items',
    guards: ['allowOnlyProfessor', 'allowOnlyLogged'],
  },
]
